import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { find } from 'lodash'
import { FC, SyntheticEvent } from 'react'
import ImageCircleIcon from '../../../../assets/icons/ImageCircle.svg'
import MemoIcon from '../../../../assets/icons/Memo.svg'
import MicrophoneIcon from '../../../../assets/icons/Microphone.svg'
import TablerIconVideo from '../../../../assets/icons/TablerIconVideo.svg'
import VolumeMaxIcon from '../../../../assets/icons/VolumeMax.svg'
import { ModelType } from '../../../../swagger/dto'

interface Props {
    value: string
    onChange: (event: SyntheticEvent, newValue: number) => void
}
export const TabsModelTypes: FC<Props> = ({ value, onChange, modelList }) => (
    <Tabs
        value={value}
        onChange={onChange}
        sx={{ p: 0, borderBottom: 'none', minHeight: '40px', '& .MuiTab-root': { height: '40px' } }}
        variant="scrollable"
        scrollButtons={false}>
        {find(modelList, {
            model_type: ModelType.TEXT,
        }) ? (
            <Tab icon={<MemoIcon />} iconPosition="start" label="Текст" value="0" />
        ) : (
            ''
        )}

        {find(modelList, {
            model_type: ModelType.IMAGE,
        }) ? (
            <Tab icon={<ImageCircleIcon />} iconPosition="start" label="Изображения" value="1" />
        ) : (
            ''
        )}

        {find(modelList, {
            model_type: ModelType.VIDEO,
        }) ? (
            <Tab icon={<TablerIconVideo />} iconPosition="start" label="Видео" value="2" />
        ) : (
            ''
        )}

        {find(modelList, {
            model_type: ModelType.SPEECH,
        }) ? (
            <Tab icon={<VolumeMaxIcon />} iconPosition="start" label="Речь" value="3" />
        ) : (
            ''
        )}

        {find(modelList, {
            model_type: ModelType.AUDIO,
        }) ? (
            <Tab icon={<MicrophoneIcon />} iconPosition="start" label="Аудио" value="4" />
        ) : (
            ''
        )}
    </Tabs>
)
